<template>
  <div>
    <div
      v-t="'c.searchResult.message.noEntries'"
      v-if="contents.length === 0 && searchTerm"
      class="add-padding-full text-center"
    />

    <div
      v-if="contents.length > 0 && searchTerm"
      class="text-center"
    >
      {{ $tc('c.searchResult.message.entries', $store.state.contents.meta.totalCount, { count: $store.state.contents.meta.totalCount }) }}
    </div>

    <component
      :is="selectedLayout"
      :entries="contents"
    />

    <button
      v-show="nextPage"
      :disabled="isLoading"
      class="add-margin-top-double button button--outline button--full button--big"
      @click="loadMore"
    >
      <span>
        <font-awesome-icon
          icon="redo"
          size="sm"
        />
        {{ isLoading ? $t('p.streamPage.label.loadingInProgress') : $t('p.streamPage.label.loadMoreContent') }}
      </span>
    </button>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import isBlank from 'is-blank'
import ContentGridView from '@/components/contents/ContentLayoutGridView'
import ContentListView from '@/components/contents/ContentLayoutListView'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  name: 'SearchResult',
  components: {
    ContentGridView,
    ContentListView,
    FontAwesomeIcon
  },
  computed: {
    ...mapState({
      filter: state => state.contentFilter.filter,
      contents: state => state.contents.contents,
      isLoading: state => state.contents.request.isLoading,
      currentPage: state => state.contentFilter.filter.page,
      meta: state => state.contents.meta,
      searchTerm: state => state.contentFilter.filter.term
    }),
    nextPage () {
      return this.meta && this.meta.nextPage
    },
    ...mapGetters([
      'isGridLayout'
    ]),
    selectedLayout () {
      return this.isGridLayout ? 'ContentGridView' : 'ContentListView'
    }
  },
  methods: {
    ...mapActions({
      loadMore: 'contents/nextPage'
    })
  }
}
</script>

<style lang="sass">

</style>




// WEBPACK FOOTER //
// src/components/search/SearchResult.vue